import Vue from 'vue'
import Router from 'vue-router'
import mainIndex from '@/components/mainIndex'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'mainIndex',
      component: mainIndex
    }
  ],
  // mode:'history'
})



// WEBPACK FOOTER //
// ./src/router/index.js